import { createIcon } from '@chakra-ui/react'

const IconPlus = createIcon({
  displayName: 'IconPlus',
  viewBox: '0 0 20 20',
  defaultProps: {
    boxSize: '20px'
  },
  path: (
    <path
      d="M10 4V16M4 10H16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  )
})

export default IconPlus
